import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    height: "143px",
    padding: "16px",
    gap: "10px",
    borderRadius: "4px",
    opacity: 1,
    backgroundColor: theme.palette.common.white,
    boxSizing: "border-box",
  },
  fieldsRow: {
    display: "flex",
    flexDirection: "row-reverse",
    alignItems: "center",
    gap: "10px",
    width: "100%",
    height: "100%",
    overflowX: "auto",
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  imageCell: {
    display: "flex",
    alignItems: "center",
    flexShrink: 0,
  },
  vehicleImage: {
    width: "63px",
    height: "63px",
    borderRadius: "4px",
    objectFit: "cover",
    flexShrink: 0,
  },
  field: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    flex: "1 1 0",
    minWidth: 0,
  },
  label: {
    fontFamily: theme.typography.fontFamily,
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "140%",
    color: theme.palette.text.primary,
    textAlign: "right",
    whiteSpace: "nowrap",
  },
  valueRow: {
    display: "flex",
    flexDirection: "row-reverse",
    alignItems: "center",
    gap: "4px",
  },
  value: {
    fontFamily: theme.typography.fontFamily,
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "140%",
    color: theme.palette.secondary.main,
    textAlign: "right",
    whiteSpace: "nowrap",
  },
  chevron: {
    fontSize: "18px !important",
    color: theme.palette.text.primary,
  },
}));
